import React from 'react';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';

const propTypes = exact({
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
});

function PackageFilterContainer({ children }) {
  return (
    <div className="PackageSearch_filter">
      <div className="PackageSearch_filterContainer">{children}</div>
    </div>
  );
}

PackageFilterContainer.propTypes = propTypes;

export default PackageFilterContainer;
